import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import FullScreenLoading from './FullScreenLoading';
import { color } from '../Styles/Base';
var Card = function (_a) {
    var children = _a.children, style = _a.style, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? color.concrete : _b, imageStyle = _a.imageStyle, ImageComponent = _a.ImageComponent, onPress = _a.onPress, loading = _a.loading, HeaderComponent = _a.HeaderComponent, cardStyle = _a.cardStyle;
    return (React.createElement(React.Fragment, null,
        React.createElement(TouchableOpacity, { onPress: onPress, disabled: !onPress },
            React.createElement(View, null, ImageComponent ? (React.createElement(View, { style: cardStyle },
                React.createElement(View, { style: [StyleSheet.absoluteFill, imageStyle] }, ImageComponent),
                React.isValidElement(HeaderComponent) && HeaderComponent,
                React.createElement(View, { style: style }, children))) : (React.createElement(View, { style: [{ backgroundColor: backgroundColor }, cardStyle] },
                React.isValidElement(HeaderComponent) && HeaderComponent,
                React.createElement(View, { style: style }, children))))),
        React.createElement(FullScreenLoading, { style: styles.fullScreenLoading, bgColor: "rgba(255,255,255,0.5)", color: "grey", isVisible: loading })));
};
var styles = StyleSheet.create({
    fullScreenLoading: {
        zIndex: 100,
    },
});
export default Card;
